import { Box, makeStyles } from '@material-ui/core'
import React from 'react'

import colors from '../../../../assets/colors'

const TONES = {
  success: { color: colors.sucess, bg: colors.bgSucess },
  error: { color: colors.error, bg: colors.bgError },
  info: { color: colors.info, bg: colors.bgInfo },
  neutral: { color: colors.gray, bg: colors.lightGray },
}

const useStyles = makeStyles({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '12px',
    fontWeight: 700,
    padding: '4px 10px',
    borderRadius: '8px',
    whiteSpace: 'nowrap',
    lineHeight: 1.4,
  },
})

export const getPlanStatusTone = varId => {
  if (varId == 40) return 'error'
  if (varId == 10) return 'info'
  return 'success'
}

export const getInvoiceStatusTone = (statusId, statusValue = '') => {
  if (statusId == 40) return 'error'

  const value = statusValue.toLowerCase()

  if (/falh|atras|venc|cancel|recus/.test(value)) return 'error'
  if (/pago|aprovad|conclu|confirmad/.test(value)) return 'success'
  if (/pend|aguard|process|analis/.test(value)) return 'info'

  return 'neutral'
}

const StatusChip = ({ label, tone = 'neutral' }) => {
  const classes = useStyles()
  const { color, bg } = TONES[tone] || TONES.neutral

  if (!label) return null

  return (
    <Box
      component="span"
      className={classes.chip}
      style={{ color, backgroundColor: bg }}
    >
      {label}
    </Box>
  )
}

export default StatusChip
